import React from 'react';
import { Plus, Landmark } from 'lucide-react';

import CustomSelect from '../../../components/ui/CustomSelect';
import DateRangeFilter from '../../../components/ui/DateRangeFilter';
import { OPERATION_TYPES_LABELS } from '../../../constants/operationTypes';

export default function ForumHeader({
  onNewDossier,
  filters,
  setFilters,
  handleDateFilter,
}) {
  const handleTypeChange = (val) => {
    setFilters((prev) => ({
      ...prev,
      type: val,
    }));
  };

  const typeOptions = Object.entries(OPERATION_TYPES_LABELS).map(
    ([key, label]) => ({
      value: key,
      label,
    })
  );

  return (
    <div
      className="
        relative z-40 overflow-visible
        flex flex-col md:flex-row
        md:items-center md:justify-between
        workspace-card
        bg-cover bg-center bg-no-repeat
        p-4 sm:p-6
        gap-6
      "
      style={{
        backgroundImage:
          "url('/assets/backgrounds/observatory_bg.png')",
      }}
    >
      {/* Voile sombre fondé sur les tokens Hipparchus */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute inset-0
          z-0
          bg-overlay
          rounded-[var(--hp-radius-lg)]
        "
      />

      {/* Partie gauche */}
      <div
        className="
          relative z-10
          flex flex-col sm:flex-row
          items-start sm:items-center
          space-y-3 sm:space-y-0
          sm:space-x-4
        "
      >
        <div
          className="
            flex h-12 w-12
            items-center justify-center
            rounded-full
            bg-secondary
            text-inverse
            shadow-hp-sm
          "
        >
          <Landmark className="h-6 w-6" />
        </div>

        <div>
          <h1 className="text-2xl font-bold text-inverse">
            Forum des dossiers
          </h1>

          <p className="mt-1 text-sm text-inverse opacity-80">
            Réception, qualification et faisabilité des nouvelles
            opportunités.
          </p>
        </div>
      </div>

      {/* Partie droite */}
      <div
        className="
          relative z-50
          flex w-full flex-col
          items-stretch
          gap-3
          md:w-auto md:flex-row md:items-center
        "
      >
        <div className="relative z-[70] w-full md:w-48">
          <CustomSelect
            value={filters?.type || ''}
            onChange={handleTypeChange}
            options={typeOptions}
            placeholder="Tous les types"
          />
        </div>

        <div className="relative z-[60] w-full md:w-auto">
          <DateRangeFilter onFilterChange={handleDateFilter} />
        </div>

        <button
          type="button"
          onClick={onNewDossier}
          className="
            btn btn-accent
            relative z-10
            w-full whitespace-nowrap
            md:w-auto
          "
        >
          <Plus className="h-5 w-5" />
          Nouveau dossier
        </button>
      </div>
    </div>
  );
}